import ShipPrice from './ShipPrice';

const Shipping = (props) => {
  const { cart, settings } = props;
  const { shipping } = cart;
  if (!cart.shipTo || shipping.length === 0) {
    return (
      <div>
        <div>Shipping:</div>
        <div>--</div>
      </div>
    );
  }
  return (
    <div>
      <div>Shipping to {cart.shipTo.stateCode}:</div>
      <ShipPrice shipping={shipping[0]} settings={settings} />
    </div>
  );
};

export default Shipping;
